import { render, staticRenderFns } from "./k2PdfEmbed.vue?vue&type=template&id=c87c215c"
import script from "./k2PdfEmbed.vue?vue&type=script&lang=js"
export * from "./k2PdfEmbed.vue?vue&type=script&lang=js"
import style0 from "./k2PdfEmbed.vue?vue&type=style&index=0&id=c87c215c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports